import { render, staticRenderFns } from "./DiagnosticTestDone.vue?vue&type=template&id=08a8d2f0&scoped=true&"
var script = {}
import style0 from "./DiagnosticTestDone.vue?vue&type=style&index=0&id=08a8d2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8d2f0",
  null
  
)

export default component.exports